/**
 * Created by Steven-DESK on 19/07/2017.
 */
$(document).ready(function () {
    $("#inschr_sub").click(function (e) {
        e.preventDefault();
        let inputs = $(".aantal_pers");
        let sum = 0;
        for (let i = 0; i < inputs.length; i++) {
            if (isNaN(inputs[i].value)) {
                sum += +0;
            } else {
                sum += +inputs[i].value;
            }
        }
        if (sum > inputs[0].max || sum === 0) {
            $(".inschr_aant_pers").fadeIn(1000).delay(5000).fadeOut(1000);
        } else $("#inschr_add_form").submit();
    });


    let regexEVSuc = /\/inschrijvingen\/index\/Save\/Success/;
    let regexEVFail = /\/inschrijvingen\/index\/Save\/Failed$/;
    let regexEVFailInf = /\/inschrijvingen\/index\/Save\/Failed\/Lijn/;

    if (regexEVSuc.test(window.location.pathname)) {
        window.history.replaceState({}, 'KBSV - Inschrijven', '/inschrijvingen');
        $(".save_succ").fadeIn(1000).delay(5000).fadeOut(1000);
    }


    if (regexEVFail.test(window.location.pathname)) {
        window.history.replaceState({}, 'KBSV - Inschrijven', '/inschrijvingen');
        $(".save_fail").fadeIn(1000).delay(5000).fadeOut(1000);
    }


    if (regexEVFailInf.test(window.location.pathname)) {
        window.history.replaceState({}, 'KBSV - Inschrijven', '/inschrijvingen');
        $(".save_fail_evi").fadeIn(1000).delay(5000).fadeOut(1000);
    }

});


//////////////////
// WEBPACK FOOTER
// ./js/inschrijven.js
// module id = 18
// module chunks = 0